var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"icon":""}},'v-btn',{ [_vm.size]: true, ..._vm.$attrs },false),_vm.$listeners),[_c('v-icon',_vm._b({},'v-icon',{ [_vm.size]: true },false),[_vm._v("mdi-information-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }